/* eslint-disable import/no-duplicates */
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function getMonthByNumber(month: number): string {
  return format(new Date(1999, month, 1), 'MMMM', { locale: ptBR });
}
